<template>
  <component :is="tag" class="display-grid-cards" :class="classCount">
    <slot />
  </component>
</template>
<script setup lang="ts">
interface Props {
  tag?: 'section' | 'div';
  count?: number;
}

const props = defineProps({
  tag: { default: 'div' },
  count: { default: -1 }
});

const classCount = computed(() =>
  props.count > -1 ? `count-${props.count}` : ''
);
</script>
<style lang="scss" scoped>
.display-grid-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(12.2rem, 1fr));
  width: 100%;
  gap: var(--gap_n);
  &.count-1,
  &.count-2,
  &.count-3,
  &.count-4 {
    grid-template-columns: repeat(auto-fit, minmax(12.2rem, 1fr));
    @include above('s') {
      max-width: 36rem;
      margin: 0 auto;
    }
  }
}
</style>
